var _desc, _linearGradient, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAutoSuggestGo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 37,
    viewBox: "0 0 41 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created using Figma")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "auto_suggest_go_svg__auto_suggest_go_svg__gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB5789"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-6;0",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE140"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-5;1",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96FBC4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-4;2",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B05DEF"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-3;3",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96FBC4"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-2;4",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE140"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "-1;5",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FB5789",
    offset: "0%"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "0;6",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE140",
    offset: "33%"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "1;7",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#96FBC4",
    offset: "66%"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "2;8",
    dur: "4s",
    repeatCount: "indefinite"
  })), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B05DEF",
    offset: "100%"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "offset",
    values: "3;9",
    dur: "4s",
    repeatCount: "indefinite"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#auto_suggest_go_svg__auto_suggest_go_svg__gradient)",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    id: "auto_suggest_go_svg__auto_suggest_go_svg__path0_fill",
    fillRule: "evenodd",
    d: "M 40.4496 17.1607L 24.8306 0.607803C 24.1015 -0.144245 22.92 -0.231271 22.0699 0.531861C 21.3099 1.21416 21.2909 2.54483 21.9937 3.28565L 34.5315 16.5523L 1.95238 16.5523C 0.874028 16.5523 6.90277e-05 17.4242 0 18.4997C 0 19.5753 0.874028 20.4472 1.95231 20.4472L 34.5315 20.4472L 21.9937 33.7138C 21.291 34.4547 21.3408 35.7526 22.0699 36.4675C 22.84 37.2219 24.1126 37.1551 24.8306 36.3915L 40.4495 19.8387C 40.911 19.3922 40.9923 18.9573 41 18.5C 41 18.0495 40.7263 17.4512 40.4496 17.1607Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutoSuggestGo);
export default __webpack_public_path__ + "static/media/auto_suggest_go.353e27bda8a6baeac27645807d92e599.svg";
export { ForwardRef as ReactComponent };